import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClockBackward = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M9.16302 17.603L12.162 14.603L12.163 9.603",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.158 6.853L10.158 3.603L14.658 0.852997",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.70697 18.6C4.6665 20.1042 6.01706 21.3191 7.61406 22.1147C9.21107 22.9102 10.9944 23.2565 12.7731 23.1163C14.5517 22.9762 16.2588 22.3549 17.7115 21.319C19.1642 20.2832 20.3078 18.8717 21.0199 17.2358C21.732 15.5999 21.9857 13.8011 21.754 12.032C21.5222 10.2629 20.8137 8.59016 19.7043 7.19286C18.5948 5.79555 17.1262 4.7263 15.4557 4.09957C13.7852 3.47285 11.9757 3.31225 10.221 3.63499",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.85202 4.93701C5.63943 5.68685 4.60176 6.68803 3.80902 7.87301",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.33598 11.5C2.08387 12.9026 2.12815 14.3425 2.46598 15.727",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgClockBackward;
